import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../services/local-storage/local-storage.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { Exportland } from '../../../gruppe-tier/classes/exportland';
import { Tierliste } from '../../../gruppe-tier/classes/tierliste';
import { istTierlisteDerselbeKunde } from '../../../gruppe-tier/tierliste-zielbetrieb-display.util';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { GruppeAbgangService } from '../gruppe-abgang.service';
import { KieneUtils } from '../../../../utils/KieneUtils';

@Component({
    selector: 'kiene-abgangsliste-schliessen-dialog',
    templateUrl: './abgangsliste-schliessen-dialog.component.html',
    styleUrls: ['./abgangsliste-schliessen-dialog.component.scss'],
})
export class AbgangslisteSchliessenDialogComponent implements OnInit, OnDestroy {
    datumCtrl = new UntypedFormControl();
    abgangsliste: Tierliste;
    hitMeldenCtrl = new UntypedFormControl(1);
    gleicheUnternehmensgruppe: boolean;
    isSaving = false;

    vvvoSubscription: Subscription;
    hitMeldenSubscription: Subscription;
    kfzCtrl = new FormControl();
    exportland: Exportland;

    constructor(
        public readonly dialogRef: MatDialogRef<AbgangslisteSchliessenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data,
        @Inject(API_BASE_URL_SERVICE) public readonly apiBaseUrl,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly appService: AppService,
        private readonly stammdatenService: StammdatenService,
        protected localStorageService: LocalStorageService,
        private readonly router: Router,
        private readonly abgangService: GruppeAbgangService,
    ) {}

    ngOnInit(): void {
        this.abgangsliste = this.data.tierliste;
        this.vvvoSubscription?.unsubscribe();
        this.vvvoSubscription = this.stammdatenService.ladeVvvos().subscribe({
            next: response => {
                let kundeGefunden = false;
                for (const c of response.records) {
                    if (KieneUtils.sameId(c.kunde_id, this.abgangsliste.kunde_id_einstallen)) {
                        kundeGefunden = true;
                        break;
                    }
                }
                this.gleicheUnternehmensgruppe = kundeGefunden;
            },
            error: () => {
                this.gleicheUnternehmensgruppe = false;
            },
        });
        this.hitMeldenSubscription?.unsubscribe();
        this.hitMeldenSubscription = this.api.getSpeicher('hit_melden').subscribe({
            next: response => {
                if (response != null && response != undefined) {
                    this.hitMeldenCtrl.setValue(response);
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der HIT-Melden-Einstellung!', err);
            },
        });

        this.datumCtrl.setValue(this.abgangsliste.datum_abgang);
        if (this.abgangsliste?.exportland_id) {
            this.exportland = new Exportland();
            this.exportland.exportland_id = this.abgangsliste.exportland_id;
            this.exportland.land = this.abgangsliste.exportland;
        }
    }

    ngOnDestroy(): void {
        this.vvvoSubscription?.unsubscribe();
        this.hitMeldenSubscription?.unsubscribe();
    }

    istDerselbeKunde() {
        // Match DB istTierlisteExtern: null kunde_id_einstallen = extern (HIT selectable)
        return istTierlisteDerselbeKunde(this.abgangsliste);
    }

    close() {
        this.dialogRef.close();
    }

    save() {
        this.appService.setBlockOnLoading(true);
        this.isSaving = true;
        this.abgangsliste.datum_abgang = this.datumCtrl.value;
        if (this.istDerselbeKunde()) {
            this.abgangsliste.abgang_melden = 0; // radiobuttons ausgeblendet
        } else {
            this.abgangsliste.abgang_melden = this.hitMeldenCtrl.value;
        }
        this.abgangsliste.haendler_uebernehmen = 0; // Händlerinformationen werden immer intern gehalten
        this.abgangsliste.status_id = 162;
        this.abgangsliste.kfz = this.kfzCtrl.value;

        this.abgangsliste.import_einstallen = this.abgangsliste.kunde_id_einstallen ? 1 : 0;

        if (
            (this.abgangsliste.reklamationen_weitergeben || this.gleicheUnternehmensgruppe) &&
            this.abgangsliste.kunde_id_einstallen
        ) {
            this.abgangsliste.reklamationen_weitergeben = 1;
        } else {
            this.abgangsliste.reklamationen_weitergeben = 0;
        }

        this.api.post(this.apiBaseUrl + 'tierliste/update_kundenportal.php', this.abgangsliste, undefined).subscribe({
            next: () => {
                this.appService.setBlockOnLoading(false);
                this.hitMeldenChanged();
                this.isSaving = false;
                this.messageService.infoMessage('Die Ausstallliste wurde erfolgreich abgeschlossen!');

                // Sende Event für Gruppen-Aktualisierung
                if (this.abgangsliste.gruppe_id_abgang) {
                    this.abgangService.gruppeAktualisieren(this.abgangsliste.gruppe_id_abgang);
                }

                if (this.gleicheUnternehmensgruppe) {
                    if (this.data.alsDialog) {
                        this.router.navigate(['/gruppen/tierlisten/tierlisten'], { queryParams: { tab: 1 } }).then();
                        this.dialogRef.close(true);
                    } else {
                        this.router
                            .navigate(['/gruppen/zugangsliste', this.abgangsliste.tierliste_id.toString()], {
                                queryParams: { tab: 1 },
                            })
                            .then();
                    }
                }
                this.dialogRef.close(true);
            },
            error: err => {
                this.appService.setBlockOnLoading(false);
                this.isSaving = false;
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    exportlandSelected(exportland: Exportland) {
        this.abgangsliste.exportland_id = exportland ? exportland.exportland_id : null;
    }

    public hitMeldenChanged(): void {
        const value = this.hitMeldenCtrl.value;
        this.api.setSpeicher('hit_melden', value).subscribe({
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern der HIT-Melden-Einstellung!', err);
            },
        });
    }
}
